import { reviewsRowsPerPage } from "../components/Charts/CustomizedTable";
import api from "../lib/api";
import { Pagination } from "../models/base.model";
import { CompareStore, ReportDataModel, ReportModel, ReportQueryParam, ReviewReport } from "../models/report.model";

export async function getReport(filter: ReportQueryParam): Promise<ReportDataModel> {
  return await api<ReportDataModel>({
    url: "report",
    method: "POST",
    data: filter,
  });
}

export async function getCompareStores(): Promise<{ rows: CompareStore[] }> {
  return await api<{ rows: CompareStore[] }>({
    url: "compare/stores",
    method: "POST",
  });
}

export async function getReviews(filter: ReportQueryParam & Pagination): Promise<{ reviews: ReviewReport[]; offset: any; total: number }> {
  return await api<{ reviews: ReviewReport[]; offset: any; total: number }>({
    url: "reviews",
    method: "POST",
    data: {
      limit: reviewsRowsPerPage,
      needTotal: true,
      ...filter,
    },
  });
}

export async function getReportGroup(filter: ReportQueryParam): Promise<ReportModel[]> {
  return (
    await api<{ reports: ReportModel[] }>({
      url: "report/group",
      method: "POST",
      data: filter,
    })
  ).reports;
}
